export enum TypeFile {
    EXCHANGE = "E",
    RECOMMENDATION = "R",
    OTHERS = "O",
    CREDENCIAL = "C",
    RECEPTION = "P",
    AGENDA_SIGNED = "A",
    LGPD_TERM = "L",
    MARRIED_LETTER = "M"
}